import { createErrorType } from '@atlassian/mpac-utils';
export const AppInstallError = createErrorType('AppInstallError', _ref => {
  let {
    code,
    message,
    addon,
    source,
    requestId
  } = _ref;
  return {
    code,
    message,
    source,
    meta: {
      addon,
      requestId
    }
  };
});

// TODO: App fetch error should ideally be replaced
// by a generic FetchError for all `fetch` failures

export const makeAppFetchError = name => {
  return createErrorType(name, _ref2 => {
    let {
      source,
      appKey,
      requestId
    } = _ref2;
    return {
      code: 'FetchError',
      message: "Failed to fetch app details for ".concat(appKey),
      source,
      meta: {
        appKey,
        requestId
      }
    };
  });
};